import { FEATURE_FLAGS, useFeatureFlag } from '../../../lib/featureFlags';
import { useAgentsAsUsersEnabled } from './useAgentsAsUsersEnabled';

/**
 * True when Voices Phase 2 (counted seats + calibration ledger) is on.
 *
 * Gate design (§2.6): Phase 2 is the same surface as Phase 1, so it reuses
 * the `agents_as_users` workspace module — resolved through the canonical
 * `useModuleGate` inside useAgentsAsUsersEnabled — with the additional
 * `voices_counted` feature flag (defaultEnabled: false) layered on top as
 * the phase gate, the same sub-flag idiom as the Overlay Wizard family.
 * Advisory remains the permanent floor: this gate only ever reveals the
 * facilitator opt-in; it never flips a seat by itself.
 */
export function useVoicesCountedEnabled(): boolean {
  const phase1 = useAgentsAsUsersEnabled();
  const counted = useFeatureFlag(FEATURE_FLAGS.VOICES_COUNTED);
  return phase1 && counted;
}
